import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useParams, Link, useHistory } from "react-router-dom";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import {
  getByIdEventTask,
  getMyEventTask,
} from "app/_services/ehs/ehsEventScheduleServices";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { updateEventTask } from "app/_services/ehs/ehsEventScheduleServices";
import { Validation } from "app/_helpers/validation/Validation";
import toastr from "toastr";
import { TASK_STATUS } from "./CONSTANT";
import { userDropdownLabel } from "app/_helpers/helper";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import YesOrNo from "../YesOrNo.component";
import MeetingTimeline from "./Component/MeetingTimeline";
import ViewCommentsComponent from "../IncidentManagement/ViewCommentsComponent";
import ViewComments from "../IncidentManagement/ViewComments";
import { getLoggedInUserId } from "../IncidentManagement/Helper";
import MultipleFileUpload from "app/views/custom/components/FileUpload/MultipleFileUpload";
import CompletionProof from "../CapaManagement/CompletionProof";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

function ViewOwner({ history }) {
  const [tab, setTab] = useState(1);
  const [form, setForm] = useState([]);
  const [errorForm, setErrorForm] = useState([]);
  const { location } = useHistory();
  console.log("+++++++++++", location);

  let { viewId, editId, siteId } = useParams();
  console.log(viewId, editId, "params");
  useEffect(() => {
    const ids = viewId || editId;
    getByIdEventTask(ids).then((response) => {
      if (!response?.data) return;
      setForm(() => {
        const ownerDataObj = response.data?.taskOwners.find(
          (d) => d.ownerId === location.state?.ownerId
        );
        const aa = response.data?.taskOwners?.map((d) => {
          return d?.userData?.firstName + " " + d?.userData?.lastName;
        });
        return {
          ...response.data,
          comment: ownerDataObj?.comment,
          ownerData: aa.join(","),
          completionProofId: ownerDataObj?.completionProofId,
          completionProof: ownerDataObj?.completionProof,
        };
      });
    });
  }, [editId, viewId]);

  useEffect(() => {
    setTab(viewId ? 1 : 2);
  }, [viewId]);

  const onFileChange = (_event, responseData) => {
    setForm((prev) => ({
      ...prev,
      completionProofId: responseData.id,
      completionProof: responseData,
    }));
  };
  const deleteDocumentFile = (_event, _index) => {
    setForm((prev) => ({ ...prev, completionProofId: null, completionProof: null }));
  };

  const onSubmit = async () => {
    const errObj = Validation(form, [
      {
        field_name: "finialStatus",
        label: "Finial Status",
        type: "string",
        isRequired: true,
      },
      {
        field_name: "comment",
        label: "Describe Actions Taken or Resolution Provided",
        type: "string",
        isRequired: true,
      },
    ]);

    setErrorForm(errObj);

    for (const key in errObj) if (errObj[key]) return;

    const response = await updateEventTask(editId, form);

    if (!response?.status) return toastr.error(response?.message);

    toastr.success("Success");
    history.push(
      (siteId ? `/sites/${siteId}` : "") +
        "/health-safety-and-environment/audits-meetings/view-tasks"
    );
  };

  console.log("form", form);

  return (
    <div>
      {editId ? (
        <MainBreadcrumb
          routeSegments={[
            { name: "Health Safety And Environment", path: "#" },
            {
              name: "OHSE Review",
              path: "/health-safety-and-environment/audits-meetings",
            },
            // {
            //   name: "My Approval Actions",
            //   path: "/health-safety-and-environment/OHSE Review Tasks/view-tasks",
            // },

            {
              name: "Edit",
            },
          ]}
        />
      ) : (
        <MainBreadcrumb
          routeSegments={[
            { name: "Health Safety And Environment", path: "#" },
            {
              name: "OHSE Review",
              path: "/health-safety-and-environment/audits-meetings",
            },
            // {
            //   name: "My Approval Actions",
            //   path: "/health-safety-and-environment/OHSE Review Tasks/view-tasks",
            // },

            {
              name: "View",
            },
          ]}
        />
      )}

      {/* <Breadcrumb
        routeSegments={[
          { name: "Health Safety And Environment" },
          {
            name: "View Task",
            path:
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/audits-meetings/view-tasks",
          },
          { name: "View Owner" },
        ]}
      /> */}
      <div className="healthSafetyEnvironmentWrapper lrgTabberWrapper mb-3">
        <div className="hseMenuLinks card">
          <a
            href
            onClick={() => setTab(1)}
            className={`pointer${tab === 1 ? " active" : ""}`}
          >
            Timeline
          </a>
          <a
            href
            onClick={() => setTab(2)}
            className={`pointer${tab === 2 ? " active" : ""}`}
          >
            Task Details
          </a>
          {form?.ohseData?.incidentReviewsData?.length ? (
            <a
              href
              onClick={() => setTab(3)}
              // style={{pointerEvents: 'none'}}
              className={`pointer${tab === 3 ? " active" : ""}`}
            >
              Workflow Inputs
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
      {tab === 1 && (
        <Col lg={12}>
          <MeetingTimeline form={form?.ohseData} />
        </Col>
      )}
      {tab === 2 && (
        <div className="card p-3 mt-4">
          <div className="simple-card-title">
            <h3 class="text-capitalize mb-0">Details</h3>
          </div>
          <div className="ehsFormWrapper">
            <Row>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Task ID</h5>
                  <p>{form?.taskId}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Task Owners</h5>
                  <p>{form?.ownerData}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">OHSE ID</h5>
                  <Link
                    to={
                      "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/" +
                      form?.ohseData?.id
                    }
                    target="_blank"
                    className=""
                  >
                    <p>{form?.ohseData?.scheduleId}</p>
                  </Link>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Task Description</h5>
                  <p>{form?.taskDescription}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Task Due Date</h5>
                  <p>{DDMMYYYYFormat(form?.taskDueDate)}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Created Date</h5>
                  <p>{DDMMYYYYHHMMAFormat(form?.createdAt)}</p>
                </div>
              </Col>
              {form?.completionDate && (
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Completion Date</h5>
                    <p>{DDMMYYYYHHMMAFormat(form?.completionDate)}</p>
                  </div>
                </Col>
              )}
              {viewId ? (
                <>
                  <Col lg={4}>
                    <div className="form-group viewbox">
                      <h5 className="w-500 mb-1">Completed</h5>
                      <p>{form?.isCompleted ? "Yes" : "No"}</p>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form-group viewbox">
                      <h5 className="w-500">Completion Proof</h5>
                      <p>
                        {form?.ownerData?.completionProof && (
                          <CompletionProof file={form?.ownerData?.completionProof} />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form-group viewbox">
                      <h5 className="w-500 mb-1">
                        Describe Actions Taken or Resolution Provided
                      </h5>
                      <p>{form?.ownerData?.comment}</p>
                    </div>
                  </Col>
                </>
              ) : (
                ""
              )}
              {editId ? (
                <>
                  <Col lg={4}>
                    <div className="form-group viewbox">
                      <h5 className="w-500 mb-1">Completed</h5>
                      <YesOrNo
                        title={""}
                        name="finialStatus"
                        value={form?.taskStatus === "completed" ? true : false}
                        onChange={({ target: { checked } }) => {
                          setForm((prev) => ({
                            ...prev,
                            taskStatus: checked ? "completed" : "open",
                          }));
                        }}
                        acceptTitle="Yes"
                        rejectTitle="No"
                      />
                      {/* <SimpleSelect
                      value={form?.taskStatus}
                      name="finialStatus"
                      onChange={({ target: { value } }) => {
                        setForm((prev) => ({
                          ...prev,
                          taskStatus: value,
                        }));
                      }}
                      className="form-control"
                      id="id"
                      label="name"
                      options={[
                        { id: "open", name: "Open" },
                        { id: "completed", name: "Completed" },
                      ]}
                      init="Select Finial "
                    ></SimpleSelect> */}
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form-group viewbox">
                      <h5 className="w-500 mb-1">Completion Proof</h5>
                      <MultipleFileUpload
                        uploadLimit={1}
                        isLabel={false}
                        clsNameCustom={"col-md-12 pl-0"}
                        labelName={"Document"}
                        onFileChange={onFileChange}
                        alias={form?.completionProof?.alias || ""}
                        deleteDocumentFile={deleteDocumentFile}
                        selectedFileArray={
                          form.completionProof ? [form.completionProof] : []
                        }
                      />
                      {/* <span className="small text-danger">{errorForm.completionProofId}</span> */}
                    </div>
                  </Col>
                </>
              ) : null}
              {editId ? (
                <Col lg={12}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">
                      Describe Actions Taken or Resolution Provided
                    </h5>
                    <textarea
                      value={form.comment}
                      name="comment"
                      onChange={({ target: { value } }) =>
                        setForm((prev) => ({ ...prev, comment: value }))
                      }
                      class="form-control"
                      style={{ height: "80px" }}
                      placeholder="Max 300 Characters"
                      maxLength={300}
                    />
                    <span className="small text-danger">{errorForm.comment}</span>
                  </div>
                </Col>
              ) : null}
            </Row>
            {editId ? (
              <div className="mb-2 text-center">
                {/* <Link to={(siteId ? `/sites/${siteId}` : "") + "/health-safety-and-environment/capa-management/manage-capa"} className="btn btn-secondary mr-2">
                Cancel
              </Link> */}
                <Button
                  onClick={onSubmit}
                  type="submit"
                  variant="primary"
                  className="m-1 text-capitalize"
                >
                  Submit
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      )}
      {tab === 3 && (
        <Col lg={12} className="pt-3">
          <ViewComments comments={form?.ohseData?.incidentReviewsData || []} />
        </Col>
      )}
      <div className="mt-4 text-center">
        <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
          Go Back
        </span>
      </div>
    </div>
  );
}

export default ViewOwner;
